import { colorOverrides as colors } from "theme/colorOverrides";

export const DOCS_BORDER = "#e6e8ef";
export const DOCS_HEADING = colors.indigo02;
export const DOCS_TEXT = colors.gray03;
export const DOCS_MUTED = colors.gray07;
export const DOCS_ACCENT = colors.brand07;

export const DOCS_CONTENT_PX = { xs: 4, sm: 4, md: 5 };

/** Left inset (px) of sidebar rows; the sidebar heading and empty state align to it. */
export const DOCS_ROW_INSET = 12;
